// extracted by mini-css-extract-plugin
module.exports = {"award":"AwardWithPlace_award__1ozPL","placeCircle":"AwardWithPlace_placeCircle__3zOvz","place":"AwardWithPlace_place__mZcYO"};